module.exports = __webpack_public_path__ + "media/images/iconSocialLink__okGreen--dark-b982fa1ff40fc5602d54cfb57c30fedd.png";